"use client"

import { Github } from "@medusajs/icons"
import { Button, Heading } from "@medusajs/ui"
import { useEffect, useState } from "react"
import Head from "@modules/layout/templates/head";

const Hero = () => {
  const [navHeight, setNavHeight] = useState(80)

  useEffect(() => {
    const updateNavHeight = () => {
      const navElement = document.getElementById('nav-header')
      if (navElement) {
        setNavHeight(navElement.offsetHeight)
      }
    }

    updateNavHeight()
    window.addEventListener('resize', updateNavHeight)
    return () => window.removeEventListener('resize', updateNavHeight)
  }, [])

  return (
    <div
      className="flex flex-col justify-between font-guton max-h-[620px] sm:max-h-none"
      style={{ height: `calc(100vh - ${navHeight}px)`, backgroundImage: `url('/hero_background.jpg')`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      <Head/>
      <div className="flex flex-col grow justify-center">
        <div className="content-container mx-auto flex flex-row justify-between items-center text-white">
          <div className="lg:1/2 xl:w-1/3">
            <p className="text-4xl lg:text-2xl lg:text-5xl mb-8 lg:mb-6 text-gray-200 font-bold">
              WHERE IMAGINATION MEETS REALITY
            </p>
            <p className="text-2xl mb-8 lg:mb-6 text-gray-200">
              Crafting premium quality apparel and merch for businesses, schools, and events since 2001.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 lg:gap-6">
              <a href="/store"
                 className="bg-white text-blue-600 px-8 py-4 rounded-lg text-xl font-medium flex items-center justify-center gap-3">
                Browse Catalog
              </a>
              <a href="https://form.jotform.com/233198313923155" target="_blank"
                 className="bg-blue-600 text-white px-8 py-4 rounded-lg text-xl font-medium flex items-center justify-center gap-3">
                Place Order
              </a>
            </div>
          </div>
          <img src={"/hero_products.png"} alt="Hero Products" className="hidden lg:block"/>
        </div>
      </div>
    </div>
  )
}

export default Hero

